/**
 * ComponentPreview - Flow component preview renderer
 *
 * This component uses the FlowComponentRegistry to dynamically render component previews.
 * No switch statements or hardcoded logic.
 */

import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import { flowComponentRegistry } from './flow-components';

const ComponentPreview = ({ component }) => {
  if (!component) {
    return (
      <Typography variant="body2" color="text.secondary">
        No component to preview
      </Typography>
    );
  }

  // Get the flow component for this type
  const flowComponent = flowComponentRegistry.get(component.type);

  if (!flowComponent) {
    return (
      <Alert severity="error">
        <Typography variant="body2">
          Unknown component type: {component.type}
        </Typography>
        <Typography variant="caption">
          This component type is not registered in the flow component system.
        </Typography>
      </Alert>
    );
  }

  // Render the flow component's preview
  return (
    <Box className="component-preview">
      {flowComponent.renderPreview(component.properties || {}, { component })}
    </Box>
  );
};

export default ComponentPreview;
